import { Card } from 'react-bootstrap';
import { ReadDefensorResponseDto } from '@/api.types';
import { LotacaoTitular } from '@/modules/reports/application/relatorios-atividades.service';
import { RELATORIO_CORES } from '../constants/relatorio-cores';

interface RelatoriosAtividadesHeaderProps {
  defensor?: ReadDefensorResponseDto;
  comarca?: string;
  vara?: string;
  titularidade?: string;
  lotacaoTitular?: LotacaoTitular | null;
  loading?: boolean;
}

export default function RelatoriosAtividadesHeader({
  defensor,
  comarca = 'Carregando...',
  vara = 'Carregando...',
  titularidade: _titularidade = 'nao-definido',
  lotacaoTitular = null,
  loading = false,
}: RelatoriosAtividadesHeaderProps) {
  const cardStyle = {
    border: `1px solid ${RELATORIO_CORES.BORDA_CARD}`,
    borderRadius: '8px',
    boxShadow: RELATORIO_CORES.SOMBRA_CARD,
  };
  const headerStyle = {
    backgroundColor: RELATORIO_CORES.CINZA_CLARO,
    color: RELATORIO_CORES.PRIMARIA,
    borderBottom: `1px solid ${RELATORIO_CORES.BORDA_CARD}`,
    borderRadius: '8px 8px 0 0',
  };

  if (loading) {
    return (
      <Card className="mb-4" style={cardStyle}>
        <Card.Header style={headerStyle}>
          <h5 className="mb-0 fw-bold" style={{ color: RELATORIO_CORES.PRIMARIA }}>Informações do Defensor(a) Público(a)</h5>
        </Card.Header>
        <Card.Body style={{ backgroundColor: RELATORIO_CORES.BRANCO }}>
          Carregando informações do defensor...
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-4" style={cardStyle}>
      <Card.Header style={headerStyle}>
        <h5 className="mb-0 fw-bold" style={{ color: RELATORIO_CORES.PRIMARIA }}>Informações do Defensor(a) Público(a)</h5>
      </Card.Header>
      <Card.Body style={{ backgroundColor: RELATORIO_CORES.BRANCO }}>
        <div className="row">
          <div className="col-md-4">
            <h6 className="text-muted">Defensor(a) Público(a):</h6>
            <p className="mb-3">
              <strong>{defensor?.pessoa?.nome || 'Não informado'}</strong>
            </p>
          </div>
          <div className="col-md-3">
            <h6 className="text-muted">Lotação:</h6>
            <p className="mb-3">
              {lotacaoTitular ? (
                <span>
                  <span className="small me-1 text-muted" title={lotacaoTitular.tipo}>{lotacaoTitular.tipoAbreviado}</span>
                  <strong>{lotacaoTitular.nome}</strong>
                </span>
              ) : (
                <span className="text-muted">Não informado</span>
              )}
            </p>
          </div>
          <div className="col-md-3">
            <h6 className="text-muted">Comarca/Vara:</h6>
            <p className="mb-0">
              <strong>{comarca}</strong>
            </p>
            <p className="small text-muted">{vara}</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
